import React from 'react'

export default function SimpleTable({
    children
}) {

    return (
        <div className='w-full overflow-x-auto'>
            <div className="table min-w-full border border-line rounded-lg overflow-hidden">
                {children} 
            </div>
        </div>
    )
}
